define((require) => {
    "use strict";

    const
        template                  = require("ui/editor/email/SendTestEmailContentView.tpl"),
        ShareMenu                 = require("ui/share/ShareMenu"),
        ShareRecipient            = require("ui/share/ShareRecipient"),
        LoggedInUserState         = require("shared/ui/user/LoggedInUserState");

    /**
     * Component representing the Send Test Email button for the <tt>SendTestEmailButtonView</tt>.
     *
     * @see SendTestEmailButtonView
     *
     * @class TestEmailRecipientsView
     *
     * @extends ShareMenu
     */
    const TestEmailRecipientsView = ShareMenu.extend({
        template,

        modelEvents: {
            "change:recipients": "_updateValidationStates"
        },
        bindings: {
            "textarea": "subjectLine"
        },

        onRender() {
            this.__super();
            this._addCurrentUserToRecipients();
        },

        _addCurrentUserToRecipients: function() {
            const currentUserEmail = LoggedInUserState.get("user").get("username");
            if (!this._getExistingRecipient(currentUserEmail)) {
                this.model.get("recipients").add(new ShareRecipient({
                    user: LoggedInUserState.get("user"),
                    email: currentUserEmail,
                    selected: true
                }));
            }
        },

        _updateValidationStates: function() {
            // OK button on choose recipients
            // Send button on main view
            if (this._getSelectedRecipientNames()) {
                this.ui.recipientsOkButton.addClass("enabled");
                this.ui.sendButton.addClass("enabled");
            } else {
                this.ui.recipientsOkButton.removeClass("enabled");
                this.ui.sendButton.removeClass("enabled");
            }
        },

        _getExistingRecipient: function(email) {
            return this.model.get("recipients").find((recipient) => {
                return recipient.get("email") === email || (recipient.get("user") && recipient.get("user").get("username") === email);
            });
        },

        /**
         * @override
         * @protected
         *
         * TODO take a look more detailed. Probably make sense to split parent function...
         */
        _addRecipient: function() {
            const email = this._validateInviteEmail();
            if (!email) {
                return;
            }

            // Add the recipient, unless it already exists
            const existingRecipient = this._getExistingRecipient(email);

            if (existingRecipient) {
                existingRecipient.set("selected", true);
            } else {
                this.model.get("recipients").add(new ShareRecipient({email: email, selected: true}));
                this.ui.recipientsList.scrollTop(this.ui.recipientsList.prop("scrollHeight"));
            }

            // Reset the button
            this.ui.recipientsAddButton.show();
            this.ui.recipientsAddInputContainer.css("visibility", "hidden");
            this.ui.recipientsAddInput.val("");
        },

        /**
         * @override
         * @protected
         */
        _send: function() {
            const recipientNames = this._getSelectedRecipientNames();
            if (recipientNames) {
                this.model.set("state", 2);
            }
        }
    });
    return TestEmailRecipientsView;
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/SendTestEmailContentView.js